var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCast = function SvgCast(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.843 11.49C38.597 9.24 35.46 8 32 8c-3.48 0-6.626 1.232-8.861 3.47-2.26 2.261-3.36 5.335-3.102 8.654C20.55 26.673 25.916 32 32 32s11.441-5.326 11.962-11.874c.261-3.289-.846-6.356-3.12-8.635ZM52.307 56H11.693a3.813 3.813 0 0 1-1.541-.304 3.56 3.56 0 0 1-1.251-.889c-.75-.832-1.053-1.969-.829-3.119.974-5.016 4.013-9.23 8.79-12.188 4.244-2.626 9.62-4.072 15.138-4.072 5.519 0 10.894 1.447 15.138 4.072 4.777 2.957 7.816 7.17 8.79 12.187.224 1.15-.079 2.287-.829 3.12a3.56 3.56 0 0 1-1.25.889c-.484.206-1.01.31-1.542.304Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCast);
export default ForwardRef;